import { render, staticRenderFns } from "./QuotaPricing.vue?vue&type=template&id=edd1f076&scoped=true"
import script from "./QuotaPricing.vue?vue&type=script&lang=js"
export * from "./QuotaPricing.vue?vue&type=script&lang=js"
import style0 from "./QuotaPricing.vue?vue&type=style&index=0&id=edd1f076&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edd1f076",
  null
  
)

export default component.exports